import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';

import ButtonAccept from '../../elements/ButtonAccept';
import ButtonDecline from '../../elements/ButtonDecline';
import Search from '../../elements/Search';
import Paginator from '../../elements/paginator';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';
import { PERMISSION } from 'crm/helpers/Permissions';

function ResellerApplicantsList() {
    const [applicants, setApplicants] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [filter, setFilter] = useState('');
    const url = '/crea/api/reseller/applicants';

    function getApplicants(page) {
        let requestUrl = url;
        requestUrl += `?page=${page}`;
        axios.get(requestUrl, { params: { filter } }).then((response) => {
            setApplicants(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    }

    useEffect(() => {
        getApplicants();
    }, []);

    useEffect(() => {
        getApplicants();
    }, [filter]);

    function filterTable(value) {
        setFilter(value);
    }

    function acceptReseller(id) {
        const acceptUrl = `${url}/${id}/accept`;
        proceedAction('Accept reseller', 'Are you sure you want to accept application for reseller?', acceptUrl);
    }

    function declineReseller(id) {
        const declineUrl = `${url}/${id}/decline`;
        proceedAction('Decline reseller', 'Are you sure you want to decline application for reseller?', declineUrl);
    }

    function proceedAction(title, swalText, url) {
        swal({
            title,
            text: swalText,
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        }).then((willDecline) => {
            if (willDecline) {
                axios.post(url).then(() => {
                    getApplicants(currentPage);
                });
            }
        });
    }

    function getResellerApplicantsList() {
        return applicants.map(({ id, phone_country, phone, state, email, reseller_debit_formatted }) => (
            <tr key={id}>
                <td>{id}</td>
                <td>{phone_country}</td>
                <td>{phone}</td>
                <td>{state}</td>
                <td>{email}</td>
                <td>{reseller_debit_formatted}</td>
                <td>
                    <ButtonAccept
                        action={() => acceptReseller(id)}
                        permissions={[PERMISSION.UPDATE_RESELLER_APPLICANT]}
                    />
                    <ButtonDecline
                        action={() => declineReseller(id)}
                        permissions={[PERMISSION.UPDATE_RESELLER_APPLICANT]}
                    />
                </td>
            </tr>
        ));
    }

    return (
        <Card title="All reseller applications">
            <Search filterTable={filterTable} />
            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Phone country</th>
                            <th>Phone</th>
                            <th>State</th>
                            <th>Email</th>
                            <th>Reseller debit</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>{getResellerApplicantsList()}</tbody>
                </table>
                <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getApplicants} />
            </div>
        </Card>
    );
}

export default ResellerApplicantsList;
